<div class="game-hub">
  <div class="hub-header">
    <h1 class="hub-title">{{'game-mode.hub.title' | translate}}</h1>
    <app-daily-bonus></app-daily-bonus>
  </div>

  <!-- Phase 2: Ryder Welcome Guide (hidden for Phase 1)
  <div class="ryder-welcome">
    <app-ryder-guide
      [expression]="'welcome'"
      [message]="getRyderWelcome()"
      [size]="'medium'">
    </app-ryder-guide>
  </div>
  -->

  <!-- Phase 2: Creature Preview (hidden for Phase 1)
  <div class="creature-preview" *ngIf="creature">
    <app-creature-display
      [creatureTypeId]="creature.creatureTypeId"
      [pose]="'idle'"
      [level]="creature.level"
      [size]="'medium'">
    </app-creature-display>
    <div class="creature-info">
      <span class="creature-name">{{creature.customName}}</span>
      <app-league-badge [level]="creature.level"></app-league-badge>
      <app-streak-display [streak]="creature.currentStreak"></app-streak-display>
    </div>
  </div>
  -->

  <!-- Menu Cards -->
  <div class="hub-cards">
    <div class="hub-card quiz-card" (click)="openQuiz()">
      <div class="card-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="22" fill="#4CAF50" opacity="0.15"/>
          <path d="M24 10C16.27 10 10 16.27 10 24C10 31.73 16.27 38 24 38C31.73 38 38 31.73 38 24C38 16.27 31.73 10 24 10ZM25 33H23V31H25V33ZM27.07 23.25L26.17 24.17C25.45 24.9 25 25.5 25 27H23V26.5C23 25.4 23.45 24.4 24.17 23.67L25.41 22.41C25.78 22.05 26 21.55 26 21C26 19.9 25.1 19 24 19C22.9 19 22 19.9 22 21H20C20 18.79 21.79 17 24 17C26.21 17 28 18.79 28 21C28 21.88 27.64 22.68 27.07 23.25Z" fill="#4CAF50"/>
        </svg>
      </div>
      <span class="card-label">{{'game-mode.hub.play-quiz' | translate}}</span>
    </div>

    <!-- Phase 2: Creature Profile card (hidden for Phase 1)
    <div class="hub-card creature-card" (click)="openCreatureProfile()">
      <div class="card-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="22" fill="#FF9800" opacity="0.15"/>
          <path d="M24 12L26.47 19.13L34 19.87L28.4 24.73L30.18 32L24 28.27L17.82 32L19.6 24.73L14 19.87L21.53 19.13L24 12Z" fill="#FF9800"/>
        </svg>
      </div>
      <span class="card-label">{{'game-mode.hub.my-creature' | translate}}</span>
    </div>
    -->

    <!-- Phase 2: School Map card (hidden for Phase 1)
    <div class="hub-card map-card" (click)="openMap()">
      <div class="card-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="22" fill="#2196F3" opacity="0.15"/>
          <path d="M20 8L12 12V36L20 32L28 36L36 32V8L28 12L20 8ZM28 33.18L20 29.36V14.82L28 18.64V33.18Z" fill="#2196F3"/>
        </svg>
      </div>
      <span class="card-label">{{'game-mode.hub.school-map' | translate}}</span>
    </div>
    -->
  </div>
</div>
